import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, ResolveFn, RouterStateSnapshot } from '@angular/router';
import { LocalStorageService } from '@df/browser/storage/local-storage.service';
import { App } from '@df/core/app';
import { PwaIntegrationService } from '@df/module-pwa/pwa-integration.service';
import { DfModalService } from '@df/ui/modal/df-modal.service';
import { ICmsContentComponentValidationService } from '@icms/core/content/component/icms-content-component-validation.service';
import { ICmsContentService } from '@icms/core/content/icms-content.service';
import { ICmsBlock } from '@icms/core/resource/block/icms-block';
import { ICmsBlockResource } from '@icms/core/resource/block/icms-block.resource';
import { NPwaTutorialModal } from './pwa-tutorial-modal.component';

/**
 * Resolver to load and display PWA tutorial modal when appropriate conditions are met
 */
export const pwaTutorialModalResolver: ResolveFn<void> = async (
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
): Promise<void> => {
    const iCmsBlockResource = inject(ICmsBlockResource);
    const localStorageService = inject(LocalStorageService);
    const pwaIntegrationService = inject(PwaIntegrationService);
    const iCmsContentComponentValidationService = inject(ICmsContentComponentValidationService);
    const iCmsContentService = inject(ICmsContentService);
    const dfModalService = inject(DfModalService);
    const app = inject(App);

    if (
        app.isPlatformBrowser &&
        (app.client.isS || app.client.isM) &&
        pwaIntegrationService.isStandalone &&
        !localStorageService.get(NPwaTutorialModal.FLAG_NAME)
    ) {
        try {
            const block: ICmsBlock | void = await iCmsBlockResource.retrieve({ bareUrl: NPwaTutorialModal.MODAL_ID }, undefined);

            if (
                block &&
                block.data?.content &&
                !block.data.content.notOpenTutorialModal &&
                !iCmsContentComponentValidationService
                    .getState$(block.data.content, iCmsContentService.getComponentMeta(NPwaTutorialModal.MODAL_ID))
                    ?.getValue()
            ) {
                // Open the modal using dfModalService
                dfModalService.open(undefined, NPwaTutorialModal.MODAL_ID, undefined, undefined);
            }
        } catch (error) {
            // Silently handle errors to prevent blocking navigation
            console.warn('Failed to load tutorial modal:', error);
        }
    }
};
